import { TApplicationState } from '../../types/redux';

export const getUtmSource = (state: TApplicationState) => state.utmSource;
